import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetSuspendedDataAlertSettingParams {
  user: string;
}

export interface IGetSuspendedDataAlertSettingResult extends IResult {
  enabled: boolean;
}
export class GetSuspendedDataAlertSettingRequest extends Request<IGetSuspendedDataAlertSettingParams, IResult> {
  constructor(params: IGetSuspendedDataAlertSettingParams) {
    super('getSuspendedDataAlertNotificationSetting', params);
  }
}
